import React from "react";
import { Card } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

export const SocialTab = ({ issue, setIssue, onSave }) => {
  const upd = (k, v) => setIssue((s) => ({ ...s, social_posts: { ...(s.social_posts || {}), [k]: v } }));
  const fields = [
    ["linkedin", "LinkedIn"],
    ["x", "X (Twitter)"],
    ["threads", "Threads"],
    ["instagram_caption", "Instagram caption"],
    ["short_share_text", "Short share text"],
  ];
  return (
    <div className="space-y-6">
      {fields.map(([k, label]) => (
        <Card key={k} className="p-6">
          <div className="kicker">{label}</div>
          <Textarea rows={3} value={issue.social_posts?.[k] || ""} onChange={(e) => upd(k, e.target.value)} className="mt-2" />
        </Card>
      ))}
      <div className="flex items-center justify-end">
        <Button onClick={onSave} className="bg-[color:var(--coh-ink)] text-white hover:bg-[color:var(--coh-ink-2)]">Save social</Button>
      </div>
    </div>
  );
};
